import { useParams } from '@tanstack/react-router';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { SchemaFormFields } from '@mews-commander/form';
import { IntegrationSettingsUpdateLayout, IntegrationUpdateForm } from '../common';
import { IntegrationUpdateFormLayout } from '../common/components/layout';
import { updateFormDefinition } from './formDefinition';
import { schema, updateSchema } from './schema';
import { useInitialValues } from './useInitialValues';
import { useUpdateHandler } from './useUpdateHandler';

export const IstatAbruzzoExportIntegrationUpdateForm = () => {
    const { id } = useParams({ from: '/_authenticated/$currentEnterpriseId/EnterpriseIntegration/$id/Update' });
    const initialValues = useInitialValues(id);
    const { mutateAsync, isPending: deleteHandlerIsPending } = useRepositoryMutation(
        'istatAbruzzoExportIntegration',
        'delete'
    );

    const { handleSubmit, isPending: updateHandlerIsPending } = useUpdateHandler(id);
    const handleDelete = async () => {
        await mutateAsync({ id });
    };

    const isLoading = updateHandlerIsPending || deleteHandlerIsPending;

    return (
        <IntegrationSettingsUpdateLayout entityName={initialValues.name ?? ''} deleteAction={handleDelete}>
            <IntegrationUpdateForm
                defaultValues={initialValues}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
                schema={updateSchema}
                values={initialValues}
            >
                <IntegrationUpdateFormLayout>
                    <SchemaFormFields schema={schema} formDefinition={updateFormDefinition} />
                </IntegrationUpdateFormLayout>
            </IntegrationUpdateForm>
        </IntegrationSettingsUpdateLayout>
    );
};
